import { render, staticRenderFns } from "./Litihengfei.vue?vue&type=template&id=f7b4ff80&"
import script from "./Litihengfei.vue?vue&type=script&lang=js&"
export * from "./Litihengfei.vue?vue&type=script&lang=js&"
import style0 from "./Litihengfei.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports